export enum TabPanelsAnimationDirection {
  RTL = "rtl",
  LTR = "ltr"
}
